/**
 * T · Helpers thème (clair / sombre).
 *
 * Source de vérité : attribut `data-theme` sur <html>. Persisté en
 * localStorage. Initialisé au boot avant le rendu React pour éviter le
 * flash.
 */

export type Theme = "light" | "dark";

const KEY = "victor_theme";

export function getTheme(): Theme {
  if (typeof window === "undefined") return "light";
  const s = window.localStorage.getItem(KEY);
  if (s === "light" || s === "dark") return s;
  // Auto : suit prefers-color-scheme
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function applyTheme(t: Theme): void {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", t);
}

export function setTheme(t: Theme): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, t);
  applyTheme(t);
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}
